export default function () {
  let chartSymbol;
  let tvWidget;
  let activeIndicators;

  return {
    chartSymbol,
    tvWidget,
    activeIndicators,
  };
}
